import { fromJS } from 'immutable';

import { LOAD_PROFILE } from './constants';

const initialState = fromJS({
  loading: true,
  name: null,
  email: null,
  avatar: null,
  company: null,
});

function userProfileReducer(state = initialState, payload) {
  switch (payload.type) {
  case LOAD_PROFILE:
    return state
      .set('loading', false)
      .set('email', payload.fields.email)
      .set('avatar', payload.fields.avatar)
      .set('name', payload.fields.name);
  default:
    return state;
  }
}

export default userProfileReducer;



/** WEBPACK FOOTER **
 ** ./src/containers/user-profile/reducer.js
 **/